import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';
import { useUIStore } from '../store/uiStore';

/**
 * Component that blocks browser navigation (back/forward buttons, URL changes)
 * when navigation is locked due to unsaved changes.
 */
export function NavigationBlocker() {
  const navigationLock = useUIStore((state) => state.navigationLock);

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) => {
      // Block navigation if locked and going to a different location
      return (
        navigationLock.isLocked &&
        currentLocation.pathname !== nextLocation.pathname
      );
    }
  );

  useEffect(() => {
    if (blocker.state === 'blocked' && navigationLock.isLocked) {
      // Store the pending navigation
      useUIStore.setState((state) => ({
        navigationLock: {
          ...state.navigationLock,
          pendingNavigation: {
            path: blocker.location.pathname,
            options: { state: blocker.location.state },
            type: 'path' as const
          }
        },
        modals: {
          ...state.modals,
          navigationConfirm: true
        }
      }));
    }
  }, [blocker.state, blocker.location, navigationLock.isLocked]);

  // When navigation is confirmed (lock is released), proceed with the blocked navigation
  useEffect(() => {
    if (blocker.state === 'blocked' && !navigationLock.isLocked && !navigationLock.pendingNavigation) {
      blocker.proceed();
    }
  }, [blocker, navigationLock.isLocked, navigationLock.pendingNavigation]);

  return null;
}

